module.exports = "https://web-assets.ifttt.com/packs/media/access_applet_card/info-drawer-bullet-stay-secure-ed688a3e.svg";